export default __webpack_public_path__ + "static/img-projects-01-thumb-89ec7cb0b0fb8d7159f8dc5cf614d544.png";